
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface NotFoundProps {
  navigate: (path: string | number) => void;
  message?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({ 
  navigate, 
  message = "The service you're looking for doesn't exist or has been removed."
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md text-center">
        <AlertTriangle className="h-12 w-12 text-yellow-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-4">Service Not Found</h1>
        <p className="text-gray-600 mb-6">
          {message}
        </p>
        <div className="flex justify-center gap-4">
          <Button onClick={() => navigate('/')}>
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};
